export const NAME_FIELD_TEST_ID = 'name-field'
export const FREQUENCY_FIELD_TEST_ID = 'frequency-field'
export const START_DATE_FIELD_TEST_ID = 'start-from-field'
export const REPEAT_INTERVAL_FIELD_TEST_ID = 'repeat-interval-field'
export const REPEAT_UNIT_FIELD_TEST_ID = 'repeat-unit-field'
export const WEEKDAY_FIELD_TEST_ID = 'weekday-field'
export const NTH_WEEKDAY_FIELD_TEST_ID = 'nth-weekday-field'
export const WEEKDAYS_FIELD_TEST_ID = 'weekdays-field'
export const REMINDER_EXECUTION_DAY_FIELD_TEST_ID = 'reminder-execution-day-field'
export const REMINDER_EXECUTION_TIME_FIELD_TEST_ID = 'reminder-execution-time-field'
export const REMINDER_TIMEZONE_FIELD_TEST_ID = 'reminder-timezone-field'
export const NOTIFICATION_CHANNEL_TOGGLE_TEST_ID = 'notification-channel-toggle'
export const NOTIFICATION_WEBHOOK_FIELD_TEST_ID = 'notification-webhook-field'
export const NOTIFICATION_WEBHOOK_FIELD_WRAPPER_TEST_ID = 'notification-webhook-field-wrapper'
export const PARTICIPANTS_STRATEGY_FIELD_TEST_ID = 'participants-strategy'
export const EXCLUDED_GROUPS_FIELD_TEST_ID = 'excluded-groups-field'
export const EXCLUDED_USERS_FIELD_TEST_ID = 'excluded-users-field'
export const GROUPS_FIELD_TEST_ID = 'groups-field'
export const USERS_FIELD_TEST_ID = 'users-field'
export const ADD_FILTER_BUTTON_TEST_ID = 'add-filter-button'
export const REMOVE_FILTER_BUTTON_TEST_ID = 'remove-filter-button'
export const FILTERS_TABLE_TEST_ID = 'filters-table'
export const ELEMENT_PROGRESS_MOVE_BACKWARD_BUTTON_TEST_ID = 'navigation-backward'
export const ELEMENT_PROGRESS_MOVE_FORWARD_BUTTON_TEST_ID = 'navigation-forward'
export const ELEMENT_PROGRESS_TABLE_HEADER_CELL_TEST_ID = 'progress-table-header-cell'
export const PROGRESS_MODULE_VALUE_TEST_ID = 'progress-value'
export const PROGRESS_MODULE_ADD_VALUE_BUTTON_TEST_ID = 'add-value-button'
export const PROGRESS_MODULE_VALUE_TOOLTIP_TEST_ID = 'progress-value-tooltip'
export const PROGRESS_MODULE_THRESHOLD_TEST_ID = 'threshold-value'
export const INLINE_THRESHOLD_UPDATE_INPUT_TEST_ID = 'threshold-update'
export const CHECKIN_MODAL_TRIGGER_BUTTON_TEST_ID = 'checkin-modal-trigger-button'
export const CHECKIN_MODAL_TRIGGER_FROM_VALUE_BUTTON_TEST_ID =
  'checkin-modal-trigger-from-value-button'
export const CHECKIN_PREVIEW_TEST_ID = 'checkin-preview'
export const CHECKIN_FIELD_TEST_ID = 'checkin-field'
export const SHOW_LATEST_CHECKIN_TRIGGER_BUTTON_TEST_ID = 'show-latest-checkin-button'
export const CHECKIN_DATEPICKER_TEST_ID = 'checkin-datepicker'
export const CHECKIN_COMMENT_FIELD_TEST_ID = 'checkin-comment-field'

export const CHECKINS_SETTINGS_PAGE_TABS_TEST_ID = 'checkins-settings-page-tabs'
export const CHECKINS_SETTINGS_BANNER_TEST_ID = 'checkins-settings-banner'

export const CHECKINS_SCHEDULES_TABLE_WRAPPER_TEST_ID = 'checkins-schedules-table-wrapper'
export const CHECKINS_SCHEDULES_TABLE_TEST_ID = 'checkins-schedules-table'
export const CHECKINS_SCHEDULES_TABLE_ROW_TEST_ID = 'checkins-schedules-table-row'
export const CHECKINS_SCHEDULES_TABLE_COLUMN_TEST_ID = 'checkins-schedules-table-column'
export const CHECKINS_SCHEDULES_TABLE_ROW_MENU_BUTTON_TEST_ID =
  'checkins-schedules-table-row-menu-button'
export const CHECKINS_SCHEDULES_TABLE_ROW_MENU_TEST_ID = 'checkins-schedules-table-row-menu'
export const CHECKINS_SCHEDULES_CREATE_BUTTON_TEST_ID = 'checkins-schedules-create-button'
export const CHECKINS_SCHEDULES_LIMIT_MESSAGE_TEST_ID = 'checkins-schedules-limit-message'

export const CHECKINS_NOTIFICATIONS_TABLE_WRAPPER_TEST_ID = 'checkins-notifications-table-wrapper'
export const CHECKINS_NOTIFICATIONS_TABLE_TEST_ID = 'checkins-notifications-table'
export const CHECKINS_NOTIFICATIONS_TABLE_ROW_TEST_ID = 'checkins-notifications-table-row'
export const CHECKINS_NOTIFICATIONS_TABLE_COLUMN_TEST_ID = 'checkins-notifications-table-column'
export const CHECKINS_NOTIFICATIONS_TABLE_ROW_MENU_BUTTON_TEST_ID =
  'checkins-notifications-table-row-menu-button'
export const CHECKINS_NOTIFICATIONS_TABLE_ROW_MENU_TEST_ID = 'checkins-notifications-table-row-menu'
export const CHECKINS_NOTIFICATIONS_CREATE_BUTTON_TEST_ID = 'checkins-notifications-create-button'
export const CHECKINS_NOTIFICATIONS_LIMIT_MESSAGE_TEST_ID = 'checkins-notifications-limit-message'
